import { render, staticRenderFns } from "./AccountSettingInformation.vue?vue&type=template&id=bdf6d120&"
import script from "./AccountSettingInformation.vue?vue&type=script&lang=js&"
export * from "./AccountSettingInformation.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingInformation.vue?vue&type=style&index=0&id=bdf6d120&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports